/* @flow */
import Link from 'components/Link';
import Group from 'entities/Group';
import * as React from 'react';

type GroupObj = { name: string, displayName?: string };
type Props = {
  group: Group | GroupObj,
  children: React.Node,
};

class GroupLink extends React.Component<Props> {
  render() {
    const { group, children, ...other } = this.props;

    if (group.name) {
      // $FlowFixMe cast
      const groupObj: GroupObj = group;
      return (
        <Link
          to={`/classes/${groupObj.name}`}
          data-test-selector={`group-link-${groupObj.name}`}
          activeClassName="active"
          {...other}>
          {children || groupObj.displayName}
        </Link>
      );
    }

    if (group.attributes) {
      // $FlowFixMe cast
      const groupEntity: Group = group;
      return (
        <Link to={groupEntity.webUrl()} activeClassName="active" {...other}>
          {children || groupEntity.getName()}
        </Link>
      );
    }

    console.error('Unexpected group type', group);
    return null;
  }
}

export default GroupLink;
